import React from "react";
import Layout from "components/common/Layout";
import Course, {
  CourseParams,
  CourseViewQuery,
  CourseViewQueryVariables,
  COURSE_VIEW_QUERY,
  getVariables,
} from "components/courses/Course";
import { PreviewData } from "helpers/preview";
import { withEnhancedServerSideProps } from "helpers/withEnhancedProps";
import { PageMeta } from "hooks/usePageMeta";

export interface CourseProps {
  preview: boolean;
  previewData: PreviewData;
  seo?: PageMeta | null;
}

const CoursePage: React.FC<CourseProps> = ({ preview, previewData, seo }) => {
  return (
    <Layout initialMeta={seo}>
      <Course preview={preview} previewData={previewData} />
    </Layout>
  );
};

export default CoursePage;

export const getServerSideProps = withEnhancedServerSideProps<CourseProps, CourseParams>(
  async ctx => {
    const { params = { slug: "" }, preview = false, previewData = {} as PreviewData } = ctx;

    try {
      if (ctx.isInitialRequest) {
        const result = await ctx.apolloClient.query<CourseViewQuery, CourseViewQueryVariables>({
          query: COURSE_VIEW_QUERY,
          variables: getVariables({
            ...params,
            preview,
            previewData,
          }),
        });

        return {
          props: {
            preview,
            previewData,
            seo: result?.data?.course?.seo,
            title: result.data.course?.title || "",
          },
        };
      }

      return {
        props: {
          preview,
          previewData,
          title: "",
        },
      };
    } catch (err) {
      return {
        props: {
          preview,
          previewData,
        },
      };
    }
  }
);
